<template>
    <b-card v-if="isLoaded">
        <b-modal ref="libraryDocument" size="sm" hide-footer hide-header centered>
            <div class="d-block text-center">
                <b-row align-h="start">
                    <b-col style="font-weight: bold; text-align: left">
                        {{$t('folder')}}:
                    </b-col>
                </b-row>
                <b-row class="mt-1">
                    <b-col>
                        <b-form-select cols="6" v-model="selectedFolderId">
                            <option :value="null">{{ $t('new') }}</option>
                            <option v-for="folder in folders" :value="folder.id">{{ folder.name }}</option>
                        </b-form-select>
                    </b-col>
                </b-row>
                <b-row v-if="!selectedFolderId" align-h="start" class="mt-3">
                    <b-col style="font-weight: bold; text-align: left">
                        {{$t('folderName')}}:
                    </b-col>
                </b-row>
                <b-row v-if="!selectedFolderId" class="mt-1">
                    <b-col>
                        <b-form-input v-model="folderName"/>
                    </b-col>
                </b-row>
                <b-row align-h="start" class="mt-3">
                    <b-col v-if="uploadedFile" style="text-align: start">
                        <upload :showUpload="false" :showDownload="false" :reactive-id="reactiveId" @onremove="handleRemoving"/>
                        <div style="font-size: 12px;">{{uploadedFile.filename | textToShortText}}</div>
                    </b-col>
                    <b-col v-else style="text-align: start">
                        <upload-regular @onupload="onupload"/>
                    </b-col>
                </b-row>
            </div>
            <b-row align-h="end">
                <b-col cols="6">
                    <b-btn size="sm" class="mt-3" variant="outline-primary" block @click="createLibraryDoc">{{$t('save')}}</b-btn>
                </b-col>
            </b-row>
        </b-modal>
        <b-row align-h="between">
            <b-col style="font-weight: bold; text-align: start;">
                <span style="text-align: center; font-size: 22px">
                    {{ $t('title') }}
                </span>
            </b-col>
            <!-- Only supervisors and admins can create library document -->
            <b-col v-if="canEditLibraryDocument" cols="2" style="font-weight: bold; text-align: end;">
                <b-btn @click="$refs.libraryDocument.show()">{{ $t('Upload File') }}</b-btn>
            </b-col>
        </b-row>
        <div style="margin-top: 50px">
            <b-modal ref="folderEdit" size="sm" hide-footer hide-header centered>
                <div class="d-block text-center">
                    <b-row align-h="start" class="mt-3">
                        <b-col style="font-weight: bold; text-align: left">
                            {{$t('newFolderName')}}
                        </b-col>
                    </b-row>
                    <b-row class="mt-1">
                        <b-col>
                            <b-form-input v-model="folderEditedName"/>
                        </b-col>
                    </b-row>
                    <b-row align-h="end">
                        <b-col cols="6">
                            <b-btn size="sm" class="mt-3" variant="outline-primary" block @click="editFolder(folderEditedName)">{{$t('save')}}</b-btn>
                        </b-col>
                    </b-row>
                </div>
            </b-modal>
            <b-modal ref="confirmFolderDelete" size="sm" hide-footer hide-header centered>
                <div class="d-block text-center">
                    <b-row align-h="start" class="mt-3" style="margin-bottom: 10px">
                        <b-col style="font-weight: bold; text-align: left">
                            {{$t('confirm')}}
                        </b-col>
                    </b-row>
                    <b-row align-h="end">
                        <b-col cols="2">
                            <b-button style="margin-right:10px" size="sm" @click="deleteFolder(true)" variant="danger">{{$t('yes')}}</b-button>
                        </b-col>
                        <b-col cols="6">
                            <b-button style="margin-right:10px" size="sm" @click="deleteFolder(false)" variant="secondary">{{$t('no')}}</b-button>
                        </b-col>
                    </b-row>
                </div>
            </b-modal>
            <b-row v-for="(doc,index) in docs" :key="index" style="margin-top: 5px">
                <b-card-header header-tag="div" class="p-1" style="width: 100%">
                    <b-btn block variant="info" @click="$root.$emit('bv::toggle::collapse', String(doc.id));">{{doc.name}}</b-btn>
                </b-card-header>
                <b-collapse :id="String(doc.id)" accordion="my-accordion" role="tabpanel">
                    <div class="edit-column">
                                <b-row  v-if="canEditLibraryDocument">
                                    <b-button style="margin-right:10px" size="sm" @click="openFolderEditModal(doc.id)" variant="info"><i class="fas fa-edit"></i></b-button>
                                    <b-button style="margin-right:10px" size="sm" @click="openFolderDeleteModal(doc.id)" variant="info"><i class="fas fa-trash-alt"></i></b-button>
                                </b-row>   
                    </div>
                    <b-card-body>
                        <div class="table-responsive mt-3">
                            <table class="table table-hover" style="table-layout: fixed; font-size: 0.875em; margin-left: calc(50% - 50vw); margin-right: calc(50% - 50vw);">
                                <thead>
                                <tr>
                                    <th style="width: 10em">{{ $t('docColumn') }}</th>
                                    <th style="width: 10em">{{ $t('uploadingDate') }}</th>
                                    <th v-if="canEditLibraryDocument" style="width: 1em">{{ $t('operation') }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="file in doc.documents">
                                    <td>
                                        <div class="tableBodyCell">
                                            <a :href="`${apiURL}/upload/${file.uuid}`" target="_blank">{{file.filename}}</a>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="tableBodyCell">
                                            {{file.createdAt | formatDate('YYYY-MM-DD') }}
                                        </div>
                                    </td>
                                    <td v-if="canEditLibraryDocument">
                                        <!-- Only supervisors and admins can delete library document -->
                                        <div v-if="canEditLibraryDocument" class="tableBodyCell">
                                            <b-button size="sm" v-b-modal.warn v-b-tooltip.hover :title="$t('delete')" @click="deleteDocument($event, file.uuid)" variant="danger"><i class="fas fa-trash-alt"></i></b-button>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </b-card-body>
                </b-collapse>
            </b-row>
        </div>
    </b-card>
    <div v-else></div>
</template>

<script>
import Upload from '../../components/Upload';
import UploadRegular from '../../components/UploadRegular';
import uuid from 'uuid/v4';
import _ from 'lodash';

export default {
    name: 'Library',
    components: {UploadRegular, Upload},
    data() {
        return {
            isLoaded: false,
            docs: [],
            folders: [],
            selectedFolderId: null,
            uploadedFile: null,
            reactiveId: uuid(),
            folderName: null,
            selectedFolderIdToEdit: null,
            folderEditedName: null
        };
    },
    methods: {
        resetLibraryDoc() {
            this.uploadedFile = null;
            this.folderName = null;
            this.selectedFolderId = null;
        },
        createLibraryDoc() {
            let payload = {
                file: this.uploadedFile,
                folderName: this.folderName,
                folderId: this.selectedFolderId
            };
            if (
                (!payload.folderName && !payload.folderId)
            ) {
                this.$toasted.error(this.$t('missingError'));
            }else{
                this.$Progress.start();
                return this.axios
                    .post('/folders', payload)
                    .then(({data}) => {
                        this.$Progress.finish();
                        if (this.selectedFolderId) {
                            this.docs.forEach((doc, index) => {
                                if (doc.id === this.selectedFolderId) {
                                    this.docs[index].documents.push(data.document);
                                }
                            });
                        } else {
                            if (data.document) {
                                this.folders.push(JSON.parse(JSON.stringify(data.folder)));
                                data.folder.documents = [data.document];
                                this.docs.push(data.folder);
                            } else {
                                let newFolder = {};
                                newFolder.id = data.id;
                                newFolder.name = data.name;
                                this.folders.push(JSON.parse(JSON.stringify(newFolder)));
                            }
                        }
                        this.$refs.libraryDocument.hide();
                        this.init();
                        this.resetLibraryDoc();
                    })
                    .catch(err => {
                        this.$toasted.error(this.$t(err.response.data.message));
                        this.$Progress.finish();
                        this.resetLibraryDoc();
                    });
            }
        },
        onupload(event) {
            this.uploadedFile = {
                filename: event.filename,
                uuid: event.fileId,
                fileUrl: event.fileUrl
            };
        },
        handleRemoving() {
            this.uploadedFile = null;
        },
        getSiteDocs() {
            return this.axios.get('/library').then(({data}) => {
                this.docs = data;
            });
        },
        getFolders() {
            return this.axios
                .get('/folders', {
                    params: {
                        folder_type: 'library'
                    }
                })
                .then(({data}) => {
                    this.folders = data;
                });
        },
        deleteDocument(event, id) {
            this.showWarnModal(event.target);
            this.$eventHub.$on(this.$store.state.modal.eventId, () => {
                this.axios
                    .delete(`/documents/${id}`)
                    .then(() => {
                        this.docs = this.docs.filter(item => {
                            return item.uuid !== id;
                        });
                        this.init();
                    })
                    .catch(() => {
                        this.showErrorNotification(
                            'Silme işlemi gerçekleştirilemedi, tekrar deneyin.'
                        );
                    });
            });
        },
        openFolderEditModal(id) {
            this.selectedFolderIdToEdit = id;
            this.folderEditedName = _.find(this.folders, function(o) {
                return o.id === id;
            }).name;
            this.$refs.folderEdit.show();
        },
        openFolderDeleteModal(id) {
            this.selectedFolderIdToEdit = id;
            this.$refs.confirmFolderDelete.show();
        },
        editFolder(folderName) {
            let folderId = this.selectedFolderIdToEdit;
            if (
                (!folderName || !folderId)
            ) {
                this.$toasted.error(this.$t('missingError'));
            }else{
                this.$refs.folderEdit.show();
                let payload = {
                    id: folderId,
                    folderName: folderName
                };
                this.$Progress.start();
                return this.axios.put('/folders', payload).then(() => {
                    this.$Progress.finish();
                    this.init().then(() => {
                        this.$refs.folderEdit.hide();
                        this.folderEditedName = null;
                    });
                });

            }
        },
        deleteFolder(bool) {
            let folderId = this.selectedFolderIdToEdit;
            if (bool) {
                let currentFolderDocs = _.find(this.docs, function(o) {
                    return o.id === folderId;
                }).documents;
                if (_.isEmpty(currentFolderDocs)) {
                    this.$Progress.start();
                    return this.axios.delete(`/folders/${folderId}`).then(() => {
                        this.$Progress.finish();
                        this.init();
                        this.$refs.confirmFolderDelete.hide();
                    });
                } else {
                    this.$toasted.error(this.$t('folderDeletionError'));
                    this.$refs.confirmFolderDelete.hide();
                }
            } else {
                this.$refs.confirmFolderDelete.hide();
            }
        },
        init() {
            let promiseArr = [this.getSiteDocs(), this.getFolders()];
            this.$Progress.start();
            return Promise.all(promiseArr).then(() => {
                this.isLoaded = true;
                this.$Progress.finish();
            });
        }
    },
    computed: {
        canEditLibraryDocument() {
            return this.$store.state.user.permissions.isAdmin;
        }
    },
    created() {
        return this.init();
    }
};
</script>

<style lang="scss">
.tab-deactive {
    .nav-link {
        background-color: #ddd;
    }
}
.table-button-delete {
    background-color: white;
    height: inherit;
    display: flex;
    justify-content: center;
    button {
        color: rgba(136, 136, 136, 0.53);
        background-color: white;
        border-color: white;
    }
}
</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "title": "Bilgi Kütüphanesi",
            "docColumn": "Doküman",
            "uploadingDate": "Yüklenme Tarihi",
            "operation": "İşlem",
            "confirm": "Klasörü silmek istediğinize emin misiniz?"
        },
        "en": {
            "title": "Information Library",
            "docColumn": "Document",
            "uploadingDate": "Uploading Date",
            "operation": "Operation",
            "confirm": "Are you sure to delete this folder?"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Library/Library.vue